/*eslint-disable*/
// helpers
import { areObjectsEqual } from "../../utils/general"

const addNameToOperations = (user, userDTO) => {
   let { firstName, lastName } = user;
    if(user.lastName === undefined || user.lastName === ''){
      lastName = ' '
    }
  const nameOperation = {
    op: "replace",
    path: "name",
    value: {
      givenName: firstName,
      familyName: lastName,
    },
  };
  userDTO.operations.push(nameOperation);
};


const getAddedGroupIds = (initialUserGroupIds, userGroupIds) => {
  return userGroupIds.filter(
    (value) => !initialUserGroupIds.includes(value)
  ) || [];
};


const getDeletedGroupIds = (initialUserGroupIds, userGroupIds) => {
   return initialUserGroupIds.filter(
      (value) => !userGroupIds.includes(value)
    ) || [];
  };

export const makeEditUserDTO = (userObj = {}, user = {}) => {
  const userDTO = {
    schemas: '["urn:ietf:params:scim:schemas:core:2.0:User"]',
    operations: [],
  };
  addNameToOperations(user, userDTO);
  return userDTO;
};

export const getInitialUser = (userObj = {}) => {
  
  const firstName = userObj?.name?.givenName;
  const lastName = userObj?.name?.familyName;
  const email = userObj?.emails?.[0].value;
  const phoneNumber = userObj?.phoneNumbers?.[0]?.value || '';
  const groups = userObj?.groups;
  const country = userObj?.addresses?.[0]?.country;
  const locale = userObj?.locale;
  return {
    firstName,
    lastName,
    email,
    phoneNumber,
    groups,
    country,
    locale,
  };
};

export const areFormValuesChanged = (userObj={}, user={}) => {
  const initialUser = getInitialUser(userObj);
  return !areObjectsEqual(initialUser, user)
}

export const getSelectedGroupsCount = (userObj) => (selectedGroups=[]) => {
  const initialUser = getInitialUser(userObj);
  const initialUserGroupIds = initialUser?.groups?.map(group => group?.value);
  const userGroupIds = selectedGroups?.map(group => group?.value);
  const addedGroupIds = getAddedGroupIds(initialUserGroupIds, userGroupIds);
  const deletedGroupIds = getDeletedGroupIds(initialUserGroupIds, userGroupIds);
  return addedGroupIds.length + deletedGroupIds.length;
}